var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-none",attrs:{"color":"success","depressed":"","outlined":"","block":"","disabled":_vm.disabled,"loading":_vm.loadingSend},on:{"click":function($event){return _vm.confirmSend()}}},[_vm._v(" Enviar a legal ")])
}
var staticRenderFns = []

export { render, staticRenderFns }